import React, { useEffect, useState, useCallback } from "react"
import { motion } from "framer-motion"
import { ArrowUpIcon } from "@heroicons/react/24/outline"

const BackToTopButton = ({ content }) => {
  const [showTopButton, setShowTopButton] = useState(false)

  // Callback to check if we should show the button based on viewport position
  const updateButtonVisibility = useCallback(() => {
    if (!content.current) return

    const halfViewportHeight = window.innerHeight / 2
    const scrollPosition = window.scrollY
    const scrollHeight = document.documentElement.scrollHeight
    const clientHeight = document.documentElement.clientHeight
    
    // Calculate distance from bottom of the page
    const distanceFromBottom = scrollHeight - scrollPosition - clientHeight
    
    // Show button when:
    // 1. Scrolled past half viewport height AND
    // 2. Not within 400px of the bottom of the page
    const shouldShow = scrollPosition > halfViewportHeight && distanceFromBottom > 270

    setShowTopButton(shouldShow)
  }, [content])

  // Set up scroll listener
  useEffect(() => {
    window.addEventListener("scroll", updateButtonVisibility)
    window.addEventListener("resize", updateButtonVisibility)

    // Initial check
    updateButtonVisibility()

    return () => {
      window.removeEventListener("scroll", updateButtonVisibility)
      window.removeEventListener("resize", updateButtonVisibility)
    }
  }, [updateButtonVisibility])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <motion.button
      className="fixed flex items-center justify-center right-2 sm:right-4 lg:right-6 bg-primary text-white rounded-full shadow-md p-2 sm:p-3"
      onClick={scrollToTop}
      initial={{ opacity: 0 }}
      animate={{ opacity: showTopButton ? 1 : 0 }}
      transition={{ duration: 0.5 }}
      style={{
        zIndex: 9999,
        display: showTopButton ? "block" : "none",
        bottom: typeof window !== 'undefined' && window.innerWidth < 640 ? "7em" : "2rem",
      }}
    >
      <ArrowUpIcon className="w-4 sm:w-6 lg:w-8 h-4 sm:h-6 lg:h-8" />
    </motion.button>
  )
}

export default BackToTopButton